import numeral from 'numeral';
import { AreaType, ElasticBounds, LocationOrigin, UserLocation } from '../../interfaces/interfaces';

// TODO: UNIT TEST
/**
 * @param price as any from raw source
 * @returns short price for marker on map
 * We have seen inconsistencies in price from MLSs
 */
export function getPrice(price: number): string {
	return numeral(price).format(price < 1000000 ? (price < 10000 ? '0,0' : '0a') : '0.0a');
}

// TODO: UNIT TEST
export function getBoundsOfCurrentMapForElasticSearch(bounds: any): ElasticBounds | undefined {
	if (!bounds) return;

	return {
		top_left: { lat: bounds?.nw.lat, lon: bounds?.nw.lng },
		bottom_right: { lat: bounds?.se.lat, lon: bounds?.se.lng },
	};
}

export function getGoogleLatLngBoundsLiteralFromElasticBounds(elasticBounds: ElasticBounds): google.maps.LatLngBoundsLiteral {
	if (elasticBounds.bottom_right && elasticBounds.top_left)
		return {
			east: elasticBounds.bottom_right.lon,
			north: elasticBounds.top_left.lat,
			south: elasticBounds.bottom_right.lat,
			west: elasticBounds.top_left.lon,
		};

	if (elasticBounds.top_right && elasticBounds.bottom_left)
		return {
			east: elasticBounds.top_right.lon,
			north: elasticBounds.top_right.lat,
			south: elasticBounds.bottom_left.lat,
			west: elasticBounds.bottom_left.lon,
		};
	if (elasticBounds.top && elasticBounds.right && elasticBounds.bottom && elasticBounds.left)
		return {
			north: elasticBounds.top,
			east: elasticBounds.right,
			south: elasticBounds.bottom,
			west: elasticBounds.left,
		};

	return {
		north: 0,
		east: 0,
		south: 0,
		west: 0,
	};
}

export const getBoundsFromGooglePlacesBounds = (bounds: google.maps.LatLngBounds): ElasticBounds | undefined => {
	if (!bounds) return;

	const northeast = bounds.getNorthEast();
	const southwest = bounds.getSouthWest();

	const top_right = { lat: northeast.lat(), lon: northeast.lng() };
	const bottom_left = { lat: southwest.lat(), lon: southwest.lng() };

	return {
		top_right: top_right,
		bottom_left: bottom_left
	};
};

export function elasticBoundsValid(bounds: ElasticBounds | undefined) {
	if (!bounds)
		return false;

	if (bounds.bottom_right && bounds.top_left) {
		const { bottom_right, top_left } = bounds;
		if (bottom_right.lat !== 0 && bottom_right.lon !== 0
			&& top_left.lat !== 0 && top_left.lon !== 0)
			return true;
	}

	if (bounds.top_right && bounds.bottom_left) {
		const { top_right, bottom_left } = bounds;
		if (top_right.lat !== 0 && top_right.lon !== 0
			&& bottom_left.lat !== 0 && bottom_left.lon !== 0)
			return true;
	}

	if (bounds.top && bounds.right && bounds.bottom && bounds.left) {
		const { top, right, bottom, left } = bounds;
		if (top !== 0 && right !== 0 && bottom !== 0 && left !== 0)
			return true;
	}

	return false;
}

/*  When property card is hovered, change
		z-index for Parent element of marker + label
		parent (auto-generated by Maps API) */
export const setHoveredElementClassName = (hoveredElement: string[]) => {
	if (hoveredElement[1]) {
		const oldElementParent = document.getElementById(`map-marker__wrapper--${hoveredElement[1]}`)?.parentElement;
		if (oldElementParent && hoveredElement[1] !== hoveredElement[0])
			oldElementParent.style.zIndex = '1000';
	}
	if (hoveredElement[0]) {
		const pinElementParent = document.getElementById(`map-marker__wrapper--${hoveredElement[0]}`)?.parentElement;
		pinElementParent && (pinElementParent.style.zIndex = '9999');
	}
};

export const stateMap: Record<string, string> = {
	'AL': 'Alabama',
	'AK': 'Alaska',
	'AS': 'American Samoa',
	'AZ': 'Arizona',
	'AR': 'Arkansas',
	'CA': 'California',
	'CO': 'Colorado',
	'CT': 'Connecticut',
	'DE': 'Delaware',
	'DC': 'District Of Columbia',
	'FM': 'Federated States Of Micronesia',
	'FL': 'Florida',
	'GA': 'Georgia',
	'GU': 'Guam',
	'HI': 'Hawaii',
	'ID': 'Idaho',
	'IL': 'Illinois',
	'IN': 'Indiana',
	'IA': 'Iowa',
	'KS': 'Kansas',
	'KY': 'Kentucky',
	'LA': 'Louisiana',
	'ME': 'Maine',
	'MH': 'Marshall Islands',
	'MD': 'Maryland',
	'MA': 'Massachusetts',
	'MI': 'Michigan',
	'MN': 'Minnesota',
	'MS': 'Mississippi',
	'MO': 'Missouri',
	'MT': 'Montana',
	'NE': 'Nebraska',
	'NV': 'Nevada',
	'NH': 'New Hampshire',
	'NJ': 'New Jersey',
	'NM': 'New Mexico',
	'NY': 'New York',
	'NC': 'North Carolina',
	'ND': 'North Dakota',
	'MP': 'Northern Mariana Islands',
	'OH': 'Ohio',
	'OK': 'Oklahoma',
	'OR': 'Oregon',
	'PW': 'Palau',
	'PA': 'Pennsylvania',
	'PR': 'Puerto Rico',
	'RI': 'Rhode Island',
	'SC': 'South Carolina',
	'SD': 'South Dakota',
	'TN': 'Tennessee',
	'TX': 'Texas',
	'UT': 'Utah',
	'VT': 'Vermont',
	'VI': 'Virgin Islands',
	'VA': 'Virginia',
	'WA': 'Washington',
	'WV': 'West Virginia',
	'WI': 'Wisconsin',
	'WY': 'Wyoming'
};

export const defaultRichmondLocation: UserLocation = {
	initialized: false,
	areaType: AreaType.Geopoint,
	centerMap: {
		lat: 37.5410,
		lng: -77.4832
	},
	boundsElastic: {
		top_left:{lat:37.659,lon:-77.697},
		bottom_right:{lat:37.432,lon:-77.256}
	},
	zoomLevel: 12,
	//city: 'richmond',
	//state: 'va',
	//zip: '',
	origin: LocationOrigin.Default
};

export const moveMapToLocation = (gmap: google.maps.Map | undefined, userLocation: UserLocation): void => {
	if (!gmap)
		return;
	if (userLocation.zoomLevel)
		gmap?.setZoom(userLocation.zoomLevel);
	if (userLocation.centerMap) {
		gmap?.setCenter(userLocation.centerMap);
	} else if (userLocation.boundsElastic) {
		gmap?.panToBounds(getGoogleLatLngBoundsLiteralFromElasticBounds(userLocation.boundsElastic));
	}
};
